export const DRAWER_OPEN = "DRAWER_OPEN"
export const DRAWER_COLLAPSE = "DRAWER_COLLAPSE"